import type {Page, Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMealSummary} from '../../domain/saved-meal';
import type {ListSavedMealsInput, SavedMealRepository} from '../ports/saved-meal.repository';

export class ListSavedMeals implements UseCase<[ListSavedMealsInput], Page<SavedMealSummary>> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(input: ListSavedMealsInput): Promise<Result<Page<SavedMealSummary>, SavedMealError>> {
    return this.repository.list(input);
  }
}
